"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CategorySelector = void 0;
var _lodashEs = require("lodash-es");
var _react = require("react");
var _useResizeObserver = _interopRequireDefault(require("use-resize-observer"));
var _ = require(".");
var _IconLibrary = require("../../packages/IconLibrary");
var _ScrollManager = _interopRequireDefault(require("../../packages/ScrollManager"));
var _Link = _interopRequireDefault(require("../Link"));
var _Text = _interopRequireDefault(require("../Text"));
var _analytics = require("../analytics");
var Styled = _interopRequireWildcard(require("./CategorySelector.styled"));
var _helpers = require("./helpers");
var _jsxRuntime = require("react/jsx-runtime");
const CategorySelector = exports.CategorySelector = (0, _analytics.withAnalytics)(function (props) {
  const {
    categories = [],
    activeCategory,
    theme,
    className,
    urlHash,
    children,
    onLeftArrowClick,
    onRightArrowClick
  } = props;
  const stickyNavRef = (0, _react.useRef)(null);
  const scrollRef = (0, _react.useRef)(null);
  const leftArrowRef = (0, _react.useRef)(null);
  const rightArrowRef = (0, _react.useRef)(null);
  const active = activeCategory || categories[0];
  const [isSmoothScrolling, setIsSmoothScrolling] = (0, _react.useState)(false);
  const [isSticky, setisSticky] = (0, _react.useState)(false);
  const [isFirstScroll, setIsFirstScroll] = (0, _react.useState)(true);
  const updateArrowStates = (0, _react.useCallback)((0, _lodashEs.debounce)(function () {
    const scrollContainer = scrollRef.current;
    const leftArrow = leftArrowRef.current;
    const rightArrow = rightArrowRef.current;
    if (!scrollContainer || !leftArrow || !rightArrow) {
      return;
    }
    const hasScroll = (0, _helpers.hasScrollBehavior)(scrollContainer);
    const isStart = (0, _helpers.isScrollPositionStart)(scrollContainer);
    const isEnd = (0, _helpers.isScrollPositionEnd)(scrollContainer);
    [leftArrow, rightArrow].forEach(function (arrow) {
      arrow.style.visibility = hasScroll ? "visible" : "hidden";
      arrow.disabled = !hasScroll || (arrow === leftArrow ? isStart : isEnd);
    });
  }, 100), []);
  (0, _useResizeObserver.default)({
    ref: scrollRef,
    onResize: updateArrowStates
  });
  const handleOnClick = function (e) {
    var _document$querySelect;
    e.preventDefault(); // Don't allow history push
    setIsSmoothScrolling(true);
    (_document$querySelect = document.querySelector(`${e.target.getAttribute("href")}`)) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.scrollIntoView({
      behavior: "smooth"
    });
  };
  const handleLeftClick = (0, _react.useCallback)(function () {
    var _scrollRef$current;
    onLeftArrowClick === null || onLeftArrowClick === void 0 ? void 0 : onLeftArrowClick();
    (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 ? void 0 : _scrollRef$current.scrollTo({
      left: scrollRef.current.scrollLeft - scrollRef.current.offsetWidth,
      behavior: "smooth"
    });
  }, [onLeftArrowClick]);
  const handleRightClick = (0, _react.useCallback)(function () {
    onRightArrowClick === null || onRightArrowClick === void 0 ? void 0 : onRightArrowClick();
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        left: scrollRef.current.scrollLeft + scrollRef.current.offsetWidth,
        behavior: "smooth"
      });
    }
  }, [onRightArrowClick]);
  (0, _react.useEffect)(function () {
    const handleFirstScrollwithHash = function (hash) {
      (0, _ScrollManager.default)(document.querySelector(hash));
      setIsFirstScroll(false);
    };
    const active = document.querySelector(`a[href="#${(0, _.getTileGridId)(activeCategory)}"]`);
    if (urlHash && isFirstScroll) {
      if (active && !isSmoothScrolling) {
        (0, _helpers.centerOn)(active, scrollRef);
        handleFirstScrollwithHash(urlHash);
      }
      return;
    }
    if (active && !isSmoothScrolling) {
      (0, _helpers.centerOn)(active, scrollRef);
    }
  }, [activeCategory, isFirstScroll, isSmoothScrolling, urlHash]);
  (0, _react.useEffect)(function () {
    const span = stickyNavRef.current; // corresponding DOM node
    const observer = new IntersectionObserver(function (_ref) {
      let [e] = _ref;
      if (e.intersectionRatio < 1) {
        setisSticky(true);
      } else {
        setisSticky(false);
      }
    }, {
      threshold: [1]
    });
    if (span) {
      observer.observe(span);
    }
    return function () {
      return observer.disconnect();
    };
  }, []);
  const activeClassname = `${className ? `${className} ` : ""}${isSticky ? "stuck" : ""}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.Wrapper, {
    theme: theme,
    ref: stickyNavRef,
    className: activeClassname,
    "data-testid": "CategorySelector",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.LeftArrow, {
      className: "LeftArrow",
      onClick: handleLeftClick,
      ref: leftArrowRef,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLibrary.Arrow, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Styled.CategorySelector, {
      ref: scrollRef,
      onScroll: updateArrowStates,
      children: [categories.map(function (i, index) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.default, {
          index: index,
          additionalAnalytics: {
            count: categories.length
          },
          onClick: handleOnClick,
          href: `#${(0, _.getTileGridId)(i)}`,
          disableRouter: true,
          className: i === active ? "active" : "",
          "data-testid": "CategorySelector",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
            children: i
          })
        }, i);
      }), children]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Styled.RightArrow, {
      className: "RightArrow",
      onClick: handleRightClick,
      ref: rightArrowRef,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLibrary.Arrow, {})
    })]
  });
})({
  _component: "CategorySelector"
});
var _default = exports.default = CategorySelector;